<script setup>

import Header from "@/components/live-editor/Header.vue";
import Timeline from "@/components/live-editor/Timeline.vue";
import {computed, onMounted, ref} from "vue";
import Storyboard from "@/components/live-editor/Storyboard.vue";
import '@/assets/css/live-editor.css';
import GlobalVideoSettings from "@/components/live-editor/GlobalVideoSettings.vue";
import store from "@/vuex/store";
import { useRouter } from "vue-router";

const router = useRouter()
const baseTimestamp = ref(Date.now() - (5 * 60 * 1000));

const stream = computed(() => store.getters["live/getStream"])

const loading = computed(() => store.getters["live/getLoading"])

onMounted(async () => {
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  store.commit('editor/setTenantId', params.get('tenant_id'));
  params = Object.fromEntries(params.entries());
  await store.dispatch('live/getRecord', params)
  if(!['pending', 'error'].includes(stream.value.status)) await router.push({name: 'preview'})
  loading.value = false;
  store.commit('live/setIsLive', true)
  store.commit('live/setLoading', false);
  store.dispatch('window/sendLoadedFlag')
})
</script>


<template>
  <div v-if="stream && ['pending', 'error'].includes(stream.status)" class=" w-full px-20 pr-8 mt-[80px] live-editor min-w-[400px]">
    <Header :baseTimestamp="baseTimestamp"/>
    <div class="mt-14 mb-10">
      <Timeline :baseTimestamp="baseTimestamp"/>
      <Storyboard/>
      <GlobalVideoSettings/>
    </div>
  </div>
</template>
